export default "__VITE_ASSET__B2Kox3Cw__"